export default __webpack_public_path__ + "52204d0ce927dde4af637a2911d3ed0b.png";